import { DEFAULT_SPACE_USERNAME } from "@/configs/system";
import type { ISpaceCompanyAccessResponseItem } from "@/api/space/dtos/authenticator.dto";
import type { EmpresaAcessoItem } from "@auth/user";

// ------------------------------- FUNCTIONS -------------------------------

export function normalizeCompanyAccess(
	input: ISpaceCompanyAccessResponseItem[] | null | undefined,
): EmpresaAcessoItem[] {
	const items = Array.isArray(input) ? input : [];
	const uniqueById = new Map<number, EmpresaAcessoItem>();

	for (const item of items) {
		const id = Number(item?.id_cad_empresa);
		const nome = String(item?.nome_empresa ?? "").trim();

		if (!Number.isFinite(id) || !nome) continue;

		if (!uniqueById.has(id))
			uniqueById.set(id, {
				id_cad_empresa: id,
				nome_empresa: nome,
			});
	}

	return Array.from(uniqueById.values()).sort((a, b) => a.id_cad_empresa - b.id_cad_empresa);
}

// "user" é apenas o marcador de autenticado consumido por FuseAuthorization/useUser;
// deve coincidir com defaultAuth em config-definicao.ts. Permissões reais vêm de src/permissoes.
export function getUserPermissionName(name_permission_group_user: string | null | undefined): string[] {
	return name_permission_group_user ? ["user"] : [];
}

export function inferIsSpaceUser(args: { readonly username?: string | null }): boolean {
	const expectedName = String(DEFAULT_SPACE_USERNAME ?? "")
		.trim()
		.toUpperCase();
	const actualName = String(args.username ?? "")
		.trim()
		.toUpperCase();

	return expectedName.length > 0 && actualName.length > 0 && actualName === expectedName;
}
